<template>
  <div>
    <Card style="margin-bottom: 50px">
      <queryInvitationDetail @queryCouponSubsResult="queryCouponSubsHandle" />
      <div style="margin-top: 20px; margin-bottom: 10px">
        <!-- <getCoupon
          style="display: inline; margin-right: 20px"
          :doWhatTemp="this.invitaCodeObj"
        /> -->
      </div>
      <el-tooltip class="item" content="(未到邀请码使用日期或邀请码已过期或版块已删除)暂无法使用" placement="bottom-start" :disabled="!dodisabled">
        <div>
          <el-button type="primary" @click="getUidCouponCode" v-if="invitaCodeObj.type == '1'" :disabled="dodisabled">
            UID兑换</el-button>
          <span v-if="invitaCodeObj.type == 1" style="font-weight: 600; font-size: 16px">邀请码:{{ invitaCodeObj.inviteCode
          }}</span>
        </div>
      </el-tooltip>
      <div>
        <el-table ref="multipleTable" :data="queryData" stripe border :header-cell-style="rowClass" tooltip-effect="dark"
          @selection-change="handleSelectionChange" v-loading.body="loading">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column v-if="invitaCodeObj.type == 2" prop="couponSN" label="兑换码" align="center" min-width="150">
          </el-table-column>
          <el-table-column prop="couponSN" label="兑换码" align="center" min-width="150" v-if="invitaCodeObj.type == 1">
            <template>
              {{ invitaCodeObj.inviteCode }}
            </template>
          </el-table-column>
          <el-table-column prop="createAt" label="生成日期" align="center" min-width="150">
            <template slot-scope="scope">
              <!-- {{ formatDate(scope.row.start) }} -->
              <span>{{ scope.row.createAt | formatDate3 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="mid" label="兑换UID" align="center" min-width="180">
          </el-table-column>
          <el-table-column prop="useAt" label="兑换日期" align="center" min-width="150">
            <template slot-scope="scope" v-if="scope.row.mid != ''">
              <span v-if="scope.row.status == 3">{{
                scope.row.useAt | formatDate3
              }}</span>
              <!-- <span v-else-if="scope.row.status == 5">{{
                scope.row.getAt | formatDate3
              }}</span> -->
            </template>
          </el-table-column>

          <el-table-column prop="status" label="状态" align="center" min-width="80">
            <template slot-scope="scope">
              <div>
                <el-tooltip content="是否解除权益？" placement="top" v-if="scope.row.status == 3">
                  <el-tag type="danger" style="
                                              background: #ccc;
                                              border: 1px solid #ccc;
                                              color: white;
                                              width: 60px;
                                              cursor: pointer;
                                            " @click="divestiture(scope.row)">已使用</el-tag>
                </el-tooltip>
                <el-tag v-if="scope.row.status == 4" type="danger">未领取</el-tag>
                <el-tag v-if="scope.row.status == 2" type="warning">已过期</el-tag>
                <el-tag v-if="scope.row.status == 5" type="success">已领取</el-tag>
                <el-tag v-if="scope.row.status == 14" type="primary">已收回</el-tag>
                <el-tag v-if="scope.row.status == 15" type="primary">已注销</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" min-width="50">
            <template slot-scope="scope">
              <el-tooltip content="立即使用" placement="top" v-if="scope.row.status == 4 && dodisabled == false">
                <el-button type="primary" size="mini" icon="el-icon-edit-outline"
                  @click="getCouponCode(scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip content="未到专享码开放日期或版块已删除" placement="top" v-if="scope.row.status == 4 && dodisabled == true">
                <div style="100px">
                  <el-button type="primary" size="mini" icon="el-icon-edit-outline" @click="getCouponCode(scope.row)"
                    :disabled="dodisabled"></el-button>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="btnFlex" style="margin-top: 30px; float: left">
          <el-button type="primary" @click="exportInvitation" icon="el-icon-document">导出</el-button>
          <el-button type="success" @click="returnGoods">回收</el-button>
          <!-- <el-button type="success" @click="multipleexchange"
            >批量使用</el-button
          > -->
        </div>
        <div class="pagination-box">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="queryParams.page" :page-sizes="[20, 50, 100]" :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="pageTotal"></el-pagination>
        </div>
      </div>
    </Card>
    <el-dialog title="兑换UID" :visible.sync="dialogVisible" center width="40%">
      <el-form :inline="true" :model="formFuzzy" label-width="80px">
        <el-form-item label="UID:">
          <el-input v-model.trim="formFuzzy.name" placeholder="输入UID" style="width: 220px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="operationGet()">确认</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="兑换UID" :visible.sync="dialogVisible1" center width="40%" :z-index="1000">
      <el-form :inline="true" :model="formFuzzy" label-width="80px">
        <el-form-item label="UID:">
          <el-input v-model="formFuzzy.name" placeholder="输入UID" style="width: 400px" type="textarea"
            :rows="6"></el-input>
          <br />
          <span style="color: red">注:多个UID换行,输入框最多可以输入2000条数据</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="operationGet()" :loading="buttonLoading">确认</el-button>
        <el-button @click="dialogVisible1 = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="cancelDialogVisible" center width="35%" class="cancelDialogVisible">
      <span style="font-size: 22px">是否需要解除权益？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="relieveEquity">解 除</el-button>
        <el-button @click="cancelDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import queryInvitationDetail from "./components/queryInvitationDetail";
import getCoupon from "./components/getCoupon";
import moment from "moment";
import { ApiMessage, formatDate } from "@/utils/util";

export default {
  name: "invitationDetail",
  components: {
    queryInvitationDetail,
    getCoupon,
  },
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
    formatDate3(d) {
      return formatDate(d, "yyyy-MM-dd");
    },
  },
  data() {
    return {
      orderId: "",
      dodisabled: false,
      dialogVisible: false,
      dialogVisible1: false,
      cancelDialogVisible: false,
      getCouponSN: "", //专享码
      queryData: [],
      queryDataList: [],
      loading: false,
      buttonLoading: false,
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      multipleSelection: [],
      invitaCodeObj: {},
      formFuzzy: {
        name: "",
      },
      queryTerms: {},
      doWhy: "", //everyone  邀请码   oneself 专享码
      uidArr: [], // 多个uid 兑换
    };
  },
  created() {
    console.log('测试')
    this.invitaCodeObj = this.$route.query;
    this.queryTerms.createdTime = "";
    console.log(this.invitaCodeObj);
    this.inviteCodeHistory();
    if (Date.parse(new Date()) < this.invitaCodeObj.startTime * 1000) {
      this.dodisabled = true;
    }
    if (Date.parse(new Date()) > this.invitaCodeObj.endTime * 1000) {
      this.dodisabled = true;
    }
    if (this.invitaCodeObj.isSecDeleted == "true") {
      this.dodisabled = true;
    }
  },

  methods: {
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    returnGoods() {
      if (this.multipleSelection.length == 0) {
        alert("请先选择要操作的数据");
        return;
      }
      let statusArr = [];
      for (let i in this.multipleSelection) {
        statusArr.push(`${this.multipleSelection[i].status}`);
      }
      var flag = statusArr.every((item) => { return item == "3" })
      if (flag == false) {
        alert("请确认选中数据中是否状态为已使用!")
        return;
      }

      console.log(statusArr)
      // return;
      this.$Modal.confirm({
        title: "确认回收？",
        content: "<ul><li>是否要回收多个UID兑换权益</li></ul>",
        onOk: () => {
          let orderIds = [];
          for (let i in this.multipleSelection) {
            orderIds.push(`${this.multipleSelection[i].orderId}`);
          }
          let params = {
            appId: this.$API.APPID,
            orderIds: orderIds,
          };
          this.$axios
            .post("/mall/order/returnGoods", params)
            .then((response) => {
              console.log(response);
              let m = response.data;
              if (m.result == 0) {
                this.$Message.success("操作成功!");
                this.inviteCodeHistory();
              } else {
                alert(m.msg)
              }
            })
            .catch((error) => {
              alert(this, error.toString(), "error");
            });

        },
      });




    },
    formatDate() {
      return "test111";
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 邀请码类型 固态码领取数量--
    getInvitaCodes() { },

    multipleexchange() { },
    exportoper() { },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.inviteCodeHistory();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.inviteCodeHistory();
    },
    inviteCodeHistory() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
        inviteId: this.invitaCodeObj.id,
      };
      if (this.queryTerms != null) {
        if (this.queryTerms.subCouponName != "") {
          params.couponSN = this.queryTerms.subCouponName;
        }
        if (this.queryTerms.Uid != "") {
          params.mid = this.queryTerms.Uid;
        }

        if (this.queryTerms.status != null && this.queryTerms.status != "") {
          params.status = Number(this.queryTerms.status);
        }
        if (
          this.queryTerms.createdTime != "" &&
          this.queryTerms.createdTime !== null
        ) {
          let startTimeString = this.queryTerms.createdTime;
          var startTime = moment(startTimeString).unix();
          params.startTime = String(startTime);
          params.endTime = String(startTime + (24 * 60 * 60 - 1));
        }
        params.pageSize = this.queryParams.pageSize;
        params.page = this.queryParams.page;
      }
      // console.log(params.startTime, params.endTime);
      this.$axios
        .post("/edu/eduAdmin/hxd/invite_code_history", params)
        .then((response) => {
          if (response.data.rc == "0") {
            this.queryData = response.data.data.list;
            this.pageTotal = response.data.data.pager.total;
          } else {
            alert(response.data.err);
          }
          this.loading = false;
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    //获取优惠券详情
    getCouponCode(row) {
      this.getCouponSN = String(row.couponSN);
      this.dialogVisible = true;
      this.doWhy = "oneSelf";
      this.formFuzzy = {
        name: "",
      };
    },
    // 获取当前的时间方法
    getTime() {
      var nowTime = Date.parse(new Date());
      return nowTime;
    },
    getUidCouponCode() {
      this.dialogVisible1 = true;
      this.doWhy = "everyone";
      this.uidArr = [];
      this.formFuzzy = {
        name: "",
      };
    },
    // 领取
    operationGet(index = 0) {
      // debugger;

      if (this.doWhy == "everyone") {
        let arr = this.formFuzzy.name.split("\n");
        var newDate = this.getTime()  // 此处获取系统当前时间点
        var nowTime = new Date();
        var year = nowTime.getFullYear();  // 获取当前时间的年
        var month = nowTime.getMonth() + 1;  // 获取当前时间的月（注意要加1）
        var date = nowTime.getDate();  // 获取当前时间的日
        // var startTime = year + '-' + month + '-' + date + '14:30:00'// 拼接开始的限制时间点,假设12点
        var startTime = year + '-' + month + '-' + date + ' 6:00:00'// 拼接结束限制时间点,假设18点
        var endTime = year + '-' + month + '-' + date + ' 8:00:00'// 拼接结束限制时间点,假设18点
        startTime = Date.parse(new Date(startTime));
        endTime = Date.parse(new Date(endTime));
        var startTime1 = year + '-' + month + '-' + date + ' 19:00:00'// 拼接开始的限制时间点,假设12点
        var endTime1 = year + '-' + month + '-' + date + ' 20:30:00'  // 拼接结束限制时间点,假设18点
        startTime1 = Date.parse(new Date(startTime1));
        endTime1 = Date.parse(new Date(endTime1));
        if ((newDate > startTime1 && newDate < endTime1) || (newDate > startTime && newDate < endTime)) { // 当前时间大于限制的开始时间并且小于限制的结束时间
          if (arr.length >= 2) {
            this.$message({
              type: 'warning',
              message: `高峰期时段6:00-8:00,晚上19:00-20:30不能进行批量操作`,
              duration: 2000
            });
            return
          }
        }
        let newArr = arr.map((item) => {
          return item.trim();
        });
        this.uidArr = newArr.filter((item) => {
          return item;
        });
        if (this.uidArr.length > 2000) {
          alert("输入框最多可以输入2000条数据");
          return;
        }

        let num = Number(this.invitaCodeObj.personLimit);
        if (this.invitaCodeObj.personLimit == 0) {
          num += 1000000000000;
        }
        if (num < this.pageTotal + this.uidArr.length) {
          alert(
            `领取数量已达最大限制 领取总数量:${this.pageTotal + this.uidArr.length
            },总量:${num}`
          );
          return;
        }
        if (index == this.uidArr.length && index != 0) {
          this.buttonLoading = false;
          this.dialogVisible1 = false;

          this.inviteCodeHistory();
          this.uidArr = [];
          this.formFuzzy = {
            name: "",
          };
          return;

        }



      }

      // return;
      if (this.formFuzzy.name == "") {
        alert("请输入UID");
        return;
      }
      this.buttonLoading = true;
      let params = {
        appId: this.$API.APPID,
        // clientId: this.formFuzzy.name,
      };
      if (this.doWhy == "oneSelf") {
        params.couponSN = this.getCouponSN;
        params.clientId = this.formFuzzy.name;
      } else if (this.doWhy == "everyone" && this.uidArr[index]) {
        params.couponSN = this.invitaCodeObj.inviteCode;
        params.clientId = this.uidArr[index];
      }
      this.eduAxiosPostRequest("/mall/device/coupon_detail", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            console.log(m.use_rule.content);
            let produContent = m.use_rule.content;
            let yQconpouSn = m.couponSN;
            if (produContent.length > 0) {
              let goodIds = produContent.map((item) => {
                return item.id;
              });

              if (this.doWhy == "oneSelf") {
                this.inviteCodeHistory();
              }
              this.operationPost(
                goodIds,
                yQconpouSn,
                this.uidArr[index],
                index
              );
            }
          } else {
            this.buttonLoading = false;
          }
        }
      ).catch((err) => {
        this.buttonLoading = false;
      })
    },
    // 兑换
    operationPost(ids, yQconpouSn, uid, index) {
      let params = {
        appId: this.$API.APPID,
        // couponSNs: this.getCouponSN.split(","),
        // uid: this.formFuzzy.name,

        quantity: Number(1), //默认 1
        goodsIds: ids,
      };
      if (this.doWhy == "oneSelf") {
        params.couponSNs = this.getCouponSN.split(",");
        params.uid = this.formFuzzy.name;
      } else if (this.doWhy == "everyone") {
        params.couponSNs = yQconpouSn.split(",");
        params.uid = uid;
      }
      this.eduAxiosPostRequest("/mall/device/pay_order", params).then((res) => {
        // debugger;
        if (res != null && res != "-800") {
          let m = JSON.parse(res);
          if (m.status == "unpaid") {
            if (this.doWhy == "oneSelf") {
              alert(`【${this.getCouponSN}】兑换失败`);
            } else if (this.doWhy == "everyone") {
              alert(`【UID:${uid}】兑换失败`);
            }
          } else {
            if (this.doWhy == "oneSelf") {
              this.$Message.success(`【${this.getCouponSN}】使用成功`);
              this.inviteCodeHistory();
              this.formFuzzy = {
                name: "",
              };
            } else if (this.doWhy == "everyone") {
              this.$Message.success(`【UID:${uid}】使用成功`);
            }
          }
        } else if (res == "-800") {
          if (this.doWhy == "oneSelf") {
            this.$Message.error(`【${this.getCouponSN}已被兑换`);
          } else if (this.doWhy == "everyone") {
            this.$Message.error(`【UID:${uid}已被兑换`);
          }
        }
        if (this.doWhy == "everyone") {
          // debugger;
          this.operationGet(++index);
        }
      });

      this.dialogVisible = false;
    },
    // 导出
    exportInvitation() {
      require.ensure([], async () => {
        const { export_json_to_excel } = require("../stu/vendor/Export2Excel");
        const tHeader = ["兑换码", "生成日期", "兑换UID", "兑换日期", "状态"];
        // 上面设置Excel的表格第一行的标题
        const filterVal = ["couponSN", "createAt", "mid", "useAt", "status"];

        console.log(this.multipleSelection, "this.multipleSelection------");
        let list = [];
        if (this.multipleSelection.length > 0) {
          list = JSON.parse(JSON.stringify(this.multipleSelection));
        } else {
          // debugger;
          let queryList = await this.inviteCodeList();
          list = JSON.parse(JSON.stringify(queryList));
        }
        var nowDate = new Date();
        var year = nowDate.getFullYear();
        var month =
          nowDate.getMonth() + 1 < 10
            ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        var day =
          nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        var dateStr = year + "" + month + "" + day;
        let datename = "兑换详情" + dateStr;
        for (let item = 0; item < list.length; item++) {
          if (list[item].createAt) {
            list[item].createAt = formatDate(list[item].createAt, "yyyy-MM-dd");
          }
          if (list[item].useAt) {
            list[item].useAt = formatDate(list[item].useAt, "yyyy-MM-dd");
          } else {
            list[item].useAt = "";
          }
          if (list[item].status == 3) {
            list[item].status = "已使用";
          }
          if (list[item].status == 4) {
            list[item].status = "未领取";
          }
          if (list[item].status == 2) {
            list[item].status = "已过期";
          }
          if (list[item].status == 5) {
            list[item].status = "已领取";
          }
          if (list[item].status == 14) {
            list[item].status = "已收回";
          }
        }

        const data = this.formatJson(filterVal, list);
        if (this.multipleSelection.length > 0) {
          export_json_to_excel(tHeader, data, datename);
          this.$message.success("导出成功,正在下载中");
          // this.$refs.multipleTable.clearSelection();
        } else {
          this.$confirm("是否导出当前所有数据", "确认信息", {
            distinguishCancelAndClose: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }).then(() => {
            export_json_to_excel(tHeader, data, datename);
            this.$message.success("导出成功,正在下载中");
          });
        }
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    inviteCodeList() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          inviteId: this.invitaCodeObj.id,
        };
        if (this.queryTerms != null) {
          if (this.queryTerms.subCouponName != "") {
            params.couponSN = this.queryTerms.subCouponName;
          }
          if (this.queryTerms.Uid != "") {
            params.mid = this.queryTerms.Uid;
          }

          if (this.queryTerms.status != null && this.queryTerms.status != "") {
            params.status = Number(this.queryTerms.status);
          }
          if (
            this.queryTerms.createdTime != "" &&
            this.queryTerms.createdTime !== null
          ) {
            let startTimeString = this.queryTerms.createdTime;
            var startTime = moment(startTimeString).unix();
            params.startTime = String(startTime);
            params.endTime = String(startTime + (24 * 60 * 60 - 1));
          }
          params.pageSize = 500;
        }
        this.$axios
          .post("/edu/eduAdmin/hxd/invite_code_history", params)
          .then((response) => {
            if (response.data.rc == "0") {
              this.queryDataList = response.data.data.list;
              resolve(response.data.data.list);
            } else {
              alert(response.data.err);
              reject();
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject();
          });
      });
    },
    // 解除权益
    divestiture(row) {
      this.cancelDialogVisible = true;
      this.orderId = Number(row.orderId);
    },
    relieveEquity() {
      let params = {
        appId: this.$API.APPID,
        orderId: this.orderId,
      };
      this.$axios
        .post("/edu/eduAdmin/hxd/return_right", params)
        .then((res) => {
          if (res.data.rc == "0") {
            console.log(res.data.data);
            this.cancelDialogVisible = false;
            this.inviteCodeHistory();
          } else {
            this.cancelDialogVisible = false;
            alert(res.data.err);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    queryCouponSubsHandle(param) {
      this.queryTerms = param;
      this.queryParams.page = 1;
      this.inviteCodeHistory();
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            if (response.data.result == "0") {
              resolve(JSON.stringify(response.data.data));
            } else if (response.data.result == "-800") {
              resolve(JSON.stringify(response.data.result));
            } else {
              alert(response.data.msg);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less" >
@import "../fyd-style";
@import "../commonEdu";

.cancelDialogVisible {
  .el-dialog__header {
    padding: 20px 20px 10px !important;
    background: none;
  }

  .el-dialog__body {
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// invitationDetail.vue?5db71180